export default [
    {
        path: '/user/notification',
        props: true,
        component: () => import('@/views/User/Notification'),
    },
];